module.exports = __webpack_public_path__ + "img/crcash_logo.a6ccb47d.png";